import {assert} from 'assert-ts';
import {Concept} from 'domainTypes';
import type {
  DataValue,
  NameVariantValue,
  Part,
  PartNameVariant,
  Valid,
} from 'schemaDefinition/types';

export const nameVariantValidator = (part: Part, value: DataValue): Valid => {
  assert(
    part.type === 'nameVariant',
    'validateNameVariant: part.type !== "nameVariant"',
  );

  if (typeof value !== 'object') {
    return 'error';
  }

  const nameVariantValue = value as NameVariantValue;
  const nameVariantPart = part as PartNameVariant;
  return (
    nameVariantPart.agentType === Concept.person
      ? nameVariantValue.name || nameVariantValue.surName
      : nameVariantValue.name
  )
    ? 'valid'
    : 'error';
};
